import React, { useCallback, useRef } from 'react';
import { Sigma } from 'sigma';
import { usePrevious, useRenderer } from '../../hooks';
import { createNodeReducer, createEdgeReducer } from '../../../lib/reducers';
import './GraphContainer.scss';
export default function GraphContainer(_a) {
    var graph = _a.graph, nodeColor = _a.nodeColor, nodeSize = _a.nodeSize, nodeLabel = _a.nodeLabel, edgeSize = _a.edgeSize, edgeColor = _a.edgeColor, labelDensity = _a.labelDensity;
    var previousNodeColor = usePrevious(nodeColor);
    var previousNodeSize = usePrevious(nodeSize);
    var previousNodeLabel = usePrevious(nodeLabel);
    var previousEdgeColor = usePrevious(edgeColor);
    var previousEdgeSize = usePrevious(edgeSize);
    var previousLabelDensity = usePrevious(labelDensity);
    var nodeReducer = createNodeReducer({
        nodeColor: nodeColor,
        nodeSize: nodeSize,
        nodeLabel: nodeLabel
    });
    var edgeReducer = createEdgeReducer({
        edgeSize: edgeSize,
        edgeColor: edgeColor
    });
    var container = useRef(null);
    var _b = useRenderer(), renderer = _b[0], setRenderer = _b[1];
    // Should we update the renderer's settings
    if (renderer) {
        if (previousNodeColor !== nodeColor ||
            previousNodeSize !== nodeSize ||
            previousNodeLabel !== nodeLabel ||
            previousEdgeSize !== edgeSize ||
            previousEdgeColor !== edgeColor) {
            renderer.setSetting('nodeReducer', nodeReducer);
            renderer.setSetting('edgeReducer', edgeReducer);
        }
        if (previousLabelDensity !== labelDensity) {
            renderer.setSetting('labelDensity', labelDensity);
        }
    }
    var setContainer = useCallback(function (node) {
        if (renderer && renderer.getGraph() !== graph) {
            renderer.kill();
            setRenderer(null);
        }
        if (node && graph) {
            var newRenderer = new Sigma(graph, node, {
                nodeReducer: nodeReducer,
                edgeReducer: edgeReducer
            });
            setRenderer(newRenderer);
        }
        container.current = node;
    }, [graph]);
    return (React.createElement("div", { id: "GraphContainer" },
        React.createElement("div", { ref: setContainer, style: { width: '100%', height: '100%' } })));
}
